import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { fetchRecords } from './missed-dossiers.action';

@Injectable({ providedIn: 'root' })
export class MissedDossiersTableService {

    constructor(
        private store: Store<RootReducerState>,
    ) { }
 
    pagination = [];
    filters = {
                created_at: "",
                club_name: "",
                club_sportlink_billing_id: "",
                member_sportlink_id: "",
                dossier_sportlink_id: "",
                outstanding_amount: ""
            };


    sidebarCount: number = 0;
    page: number = 1;
    lastPage: number;
    limit: number = 10;
    initialSortColumn = 'created_at';
    initialSortDirection = 'desc';
    sortColumn = this.initialSortColumn;
    sortDirection = this.initialSortDirection;
    hasFilter = false;
    associations = [];
    columns = [
                { prop: 'created_at', name: 'COMMON.created-date', sortable: true, hasFilter: true, filter: "date", widthSet: 140},
                { prop: 'club_name', name: 'MISSED_DOSSIERS.club-name', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'club_sportlink_billing_id', name: 'MISSED_DOSSIERS.club-billing-id', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'member_sportlink_id', name: 'MISSED_DOSSIERS.member-sportlink-id', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'dossier_sportlink_id', name: 'MISSED_DOSSIERS.dossier-sportlink-id', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'outstanding_amount', name: 'MISSED_DOSSIERS.outstanding', sortable: true, hasFilter: true, filter: "input", widthSet: 100},
                { prop: 'failed_reason', name: 'MISSED_DOSSIERS.failed-reason', sortable: true, hasFilter: false, filter: "input"},
                { prop: 'actions', name: 'COMMON.actions', sortable: false, hasFilter: false, filter: "", widthSet: 100}
            ];

    loadRecords() {
        this.hasFilter = this.hasActiveFilters();
        this.store.dispatch(fetchRecords());
    }

    hasActiveFilters(){

        if(
            (Object.values(this.filters).some(value => value !== '' && value !== null)) ||
            (this.sortDirection !== this.initialSortDirection || this.sortColumn !== this.initialSortColumn)
        )
            return true;
        else
            return false;        
    }

    resetFilters(){
        this.filters = {
            created_at: "",
            club_name: "",
            club_sportlink_billing_id: "",
            member_sportlink_id: "",
            dossier_sportlink_id: "",
            outstanding_amount: ""
        }

        this.sortDirection = this.initialSortDirection;
        this.sortColumn = this.initialSortColumn;

        this.loadRecords();
    }

}